import { render, staticRenderFns } from "./Unordered.vue?vue&type=template&id=351cf756"
import script from "./Unordered.vue?vue&type=script&lang=js"
export * from "./Unordered.vue?vue&type=script&lang=js"
import style0 from "./Unordered.vue?vue&type=style&index=0&id=351cf756&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports